"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "plugin.pluginJourney.errors.service": "Service error",
    "plugin.pluginJourney.select.default": "Choose option",
    "plugin.pluginJourney.errors.sessionExpired": "Session expired"
};
//# sourceMappingURL=messages.en-GB.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/messages/messages.en-GB.js
// module id = 2271
// module chunks = 0